import { render } from "./CustomerInfo.vue?vue&type=template&id=73cbda3e&scoped=true"
import script from "./CustomerInfo.vue?vue&type=script&lang=js"
export * from "./CustomerInfo.vue?vue&type=script&lang=js"

import "./CustomerInfo.vue?vue&type=style&index=0&id=73cbda3e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cbda3e"],['__file',"src/views/h5/common/basedata/partner/customer/CustomerInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73cbda3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73cbda3e', __exports__)) {
    api.reload('73cbda3e', __exports__)
  }
  
  module.hot.accept("./CustomerInfo.vue?vue&type=template&id=73cbda3e&scoped=true", () => {
    api.rerender('73cbda3e', render)
  })

}


export default __exports__